'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (Component) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var propTypes = Component.propTypes || {};
  var dataKeys = Object.keys(props);

  return dataKeys.reduce(function (acc, key) {
    if (!key) {
      return acc;
    }

    var hasPropType = propTypes[key] !== undefined;
    var isDataProp = key.indexOf('data-') === 0;
    var isAriaProp = key.indexOf('aria-') === 0;

    if (hasPropType || isDataProp || isAriaProp) {
      acc[key] = props[key];
    }
    return acc;
  }, {});
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.33/js/pickValidProps.js
// module id = 332
// module chunks = 0 1